import TextField from '@mui/material/TextField';
import React from "react";
import useDebugInformation from '../../../../../../../../hooks/useDebugInformation';
import { handleBasicChange } from '../../../../../../../../utilities/general';
import { Paper } from '@mui/material';
import { useAppSelector } from "@store/hooks";
import { state } from '../../../../../../../../interfaces/interfaces';

// namespace constants
const name = "AppointmentNotes";

// AppointmentNotesProps type
type AppointmentNotesProps = {
    parent: string
}

const AppointmentNotes: React.FC<AppointmentNotesProps> = ({ parent }) => {
    const appointmentGeneralNotes = useAppSelector(({ ui }) => ui.AppointmentGeneralNotes)
    const debugName = `${parent}▷[${name}]`

    useDebugInformation(debugName, { appointmentGeneralNotes })

    return (
        <Paper elevation={3} sx={{ mt: 1 }}>
            <TextField
                onChange={(e) => { handleBasicChange(e); state.NotesAppointment = e.target.value }}
                id="filled-multiline-static"
                label="Appointment notes"
                name="AppointmentGeneralNotes"
                multiline
                rows={4}
                value={appointmentGeneralNotes}
                variant="outlined"
                fullWidth
                sx={{ p: 1 }}
            />
        </Paper>
    )
}

AppointmentNotes.displayName = name;


export default React.memo(AppointmentNotes);